import DeauvilleOctober2025 from "../../components/before-after/DeauvilleOctober2025";

const DeauvilleOctober2025View = () => {

    return (
        <div className="before-after-deauville-october-2025">
            <DeauvilleOctober2025/>
        </div>
    );
};

export default DeauvilleOctober2025View;